__turbopack_context__.v({
  "black-bt": "privacy-module-scss-module__mU4WVa__black-bt",
  "breadcrumb": "privacy-module-scss-module__mU4WVa__breadcrumb",
  "btnCustom": "privacy-module-scss-module__mU4WVa__btnCustom",
  "formData": "privacy-module-scss-module__mU4WVa__formData",
  "formGroup": "privacy-module-scss-module__mU4WVa__formGroup",
  "heading": "privacy-module-scss-module__mU4WVa__heading",
  "marginTop": "privacy-module-scss-module__mU4WVa__marginTop",
  "oh": "privacy-module-scss-module__mU4WVa__oh",
  "pageTitle": "privacy-module-scss-module__mU4WVa__pageTitle",
  "relative": "privacy-module-scss-module__mU4WVa__relative",
  "top_0": "privacy-module-scss-module__mU4WVa__top_0",
  "ul2Data": "privacy-module-scss-module__mU4WVa__ul2Data",
  "ulData": "privacy-module-scss-module__mU4WVa__ulData",
});
